import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { SimpleGrid, VStack } from '@chakra-ui/react';

import { formatAmount } from 'common/formatAmount';
import SunshineCard from 'components/_core/SunshineCard';
import Text from 'components/_core/Text';
import { TeamMemberRequestStatusBadge } from 'components/TeamMemberRequestStatusBadge';
import { formatDate, P } from 'helpers/date';

import { ExpenseClaimRequestsListItemRequestFragment } from '../../../../../../hooks/useManagedUserExpenseClaimRequests/managedUserExpenseClaimRequests.gql';
import * as routes from '../../../../../../routes';

interface ExpenseClaimRequestListItemProps {
  isSelected: boolean;
  request: ExpenseClaimRequestsListItemRequestFragment;
}

export const ExpenseClaimRequestListItem: FC<
  ExpenseClaimRequestListItemProps
> = ({ isSelected, request }) => {
  return (
    <SunshineCard
      alignItems="center"
      as={Link}
      isActive={isSelected}
      to={routes.getExpenseClaimRequestPath(request.teamMembersRequestId)}
    >
      <SimpleGrid
        alignItems="center"
        columns={2}
        spacing="space-40"
        width="100%"
      >
        <VStack alignItems="flex-start" spacing="space-0">
          <SunshineCard.Title>
            {request.requesterPayload.reseller}
          </SunshineCard.Title>
          <SunshineCard.Text noOfLines={1}>
            {request.requesterPayload.description}
          </SunshineCard.Text>
        </VStack>
        <SimpleGrid
          gridTemplateColumns="1fr 4fr 1fr"
          spacing="space-40"
          width="100%"
        >
          <Text fontWeight={500} textAlign="left" variant="secondary">
            {formatDate(new Date(request.createdAt), P)}
          </Text>
          <TeamMemberRequestStatusBadge
            from="managed-user"
            justifySelf="center"
            request={request}
          />
          <Text
            fontWeight={500}
            sx={{
              fontFeatureSettings: 'tnum',
              fontVariantNumeric: 'tabular-nums',
            }}
            textAlign="right"
            variant="primary"
          >
            {formatAmount({
              forcePlusSign: false,
              value: request.requesterPayload.amount.total / 100,
              withNoMinorUnitDigits: true,
            })}
          </Text>
        </SimpleGrid>
      </SimpleGrid>
    </SunshineCard>
  );
};
